import { toggleLoginPopup } from "@/store/slices";
import { useDispatch } from "react-redux"

export const useLoginToggle = () =>{
    const dispatch = useDispatch();

    const handleLoginToggle = (args) =>{
        dispatch(toggleLoginPopup(args))
    }
    return handleLoginToggle;
}